import {
  EnvironmentProviders,
  inject,
  InjectionToken,
  provideEnvironmentInitializer,
  Provider,
  signal,
} from '@angular/core';
import { isDefinedNotEmpty, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { LinkModule, MenuItemService } from '@softline/application';

export const SOFTLINE_CONFIG_MODULES_STATIC_LINKS = new InjectionToken<LinkModule[]>(
  'SOFTLINE_CONFIG_MODULES_STATIC_LINKS'
);

export interface ModuleOverviewConfig {
  preserveProviderOrder?: boolean;
}

export const SOFTLINE_CONFIG_MODULES = new InjectionToken<ModuleOverviewConfig>(
  'SOFTLINE_CONFIG_MODULES'
);

export function provideSoftAppsLinkModule(module: Omit<LinkModule, 'type'>) {
  return {
    provide: SOFTLINE_CONFIG_MODULES_STATIC_LINKS,
    useValue: {
      ...module,
      type: 'link',
    },
    multi: true,
  };
}

export const moduleProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'app-overview',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'app-overview',
      language: 'en',
      translations: en,
    });

    const menuItemService = inject(MenuItemService);
    menuItemService.add(
      signal([
        {
          name: 'moduleRoute',
          type: 'route',
          outlet: 'nav-static',
          priority: 1,
          routerLink: ['/'],
          icon: 'fa-regular fa-grid',
          title: '#APP_OVERVIEW.ALL_APPLICATIONS',
        },
      ])
    );
  }),
];

export function provideModuleOverview(config?: ModuleOverviewConfig) {
  const providers = [...moduleProviders];

  if (isDefinedNotEmpty(config))
    providers.push({
      provide: SOFTLINE_CONFIG_MODULES,
      useValue: config,
    });

  return providers;
}
